import { render, staticRenderFns } from "./invoice-apply.vue?vue&type=template&id=227d6153&scoped=true&"
import script from "./invoice-apply.vue?vue&type=script&lang=js&"
export * from "./invoice-apply.vue?vue&type=script&lang=js&"
import style0 from "./invoice-apply.vue?vue&type=style&index=0&id=227d6153&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227d6153",
  null
  
)

export default component.exports